const $inject = [];

const hotelProviderBrandFilter = () => {
  return (brand) => {
    const brandParents = {
      CON: 'CTM',
    };

    return brandParents[brand] || brand;
  };
};

hotelProviderBrandFilter.$inject = $inject;

export default hotelProviderBrandFilter;



// WEBPACK FOOTER //
// ./src/filters/hotelProviderBrandFilter.js